.screen {

  min-height: 100vh;
  min-height: 100dvh;
  display: grid;
  place-items: center;
  overflow-y: auto;
  padding-block-start: max(var(--space-4), env(safe-area-inset-top));
  padding-block-end: max(var(--space-4), env(safe-area-inset-bottom));
  padding-inline-start: max(var(--space-2), env(safe-area-inset-left));
  padding-inline-end: max(var(--space-2), env(safe-area-inset-right));
  background: var(--color-canvas);
  color: var(--color-text-body);
}

.card,
.cardWide {
  width: min(100%, 30rem);
  padding: clamp(var(--space-2), 4vw, var(--space-4));
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-overlay);
  background: var(--color-recessed);
}

.cardWide {
  width: min(100%, 56rem);
}

.header {
  margin-block-end: var(--space-3);
}

.header h1,
.choice h2,
.totpSetup h2,
.form h2 {
  margin: 0;
  color: var(--color-text-primary);
  line-height: 1.15;
}

.header p:last-child,
.help,
.loadingText {
  color: var(--color-text-secondary);
}

.eyebrow {
  margin: 0 0 var(--space-1);
  color: var(--color-text-body);
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.16em;
}

.form,
.choice,
.totpSetup {
  display: grid;
  gap: var(--space-2);
}

.form label {
  color: var(--color-text-body);
  font-weight: 650;
}

.keyboardSafeControl {
  width: 100%;
  min-height: var(--target-min);
  padding: 0 var(--space-2);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-surface);
  color: var(--color-text-primary);
  caret-color: var(--color-text-primary);
  font: inherit;
  scroll-margin-block: 25dvh;
}

.primaryButton:focus-visible {
  outline-color: var(--focus-inverse-outline-color);
  box-shadow: var(--focus-inverse-keyline);
}

.primaryButton,
.secondaryButton,
.linkButton {
  min-height: var(--target-min);
  border-radius: var(--radius-control);
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.primaryButton,
.secondaryButton {
  width: 100%;
  padding: 0 var(--space-2);
}

.primaryButton {
  border: 1px solid var(--color-action-inverse);
  background: var(--color-action-inverse);
  color: var(--color-action-inverse-text);
}

.primaryButton:hover:not(:disabled) {
  opacity: 0.88;
}

.secondaryButton {
  border: 1px solid var(--color-boundary);
  background: var(--color-surface-raised);
  color: var(--color-text-primary);
}

.secondaryButton:hover:not(:disabled) {
  border-color: var(--color-text-tertiary);
}

.linkButton {
  justify-self: center;
  padding: 0 var(--space-1);
  border: 0;
  background: transparent;
  color: var(--color-text-body);
  text-decoration: underline;
  text-underline-offset: 0.2em;
}

.primaryButton:disabled,
.secondaryButton:disabled,
.linkButton:disabled,
.keyboardSafeControl:disabled {
  border-color: var(--color-boundary);
  background: var(--color-surface-raised);
  color: var(--color-text-tertiary);
  cursor: wait;
}

.divider {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: var(--space-2);
  margin: var(--space-2) 0;
  color: var(--color-text-tertiary);
  font-size: 0.8125rem;
}

.divider::before,
.divider::after {
  height: 1px;
  background: var(--color-hairline);
  content: "";
}

.messageRegion {
  min-height: 2.75rem;
  margin-block-start: var(--space-2);
  padding: var(--space-1) var(--space-2);
  border: 2px solid transparent;
  border-radius: var(--radius-surface);
}

.messageRegion[data-error="true"] {
  border-color: var(--color-boundary);
  background: var(--color-surface-raised);
}

.errorMessage {
  margin: 0;
  color: var(--color-text-primary);
  font-weight: 700;
}

.setupChoices {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-3);
}

.choice {
  align-content: start;
  padding: var(--space-2);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-surface);
  background: var(--color-surface);
}

.totpSetup {
  justify-items: center;
}

.totpSetup .form,
.totpSetup .backupCodes {
  width: min(100%, 30rem);
}

.qrCode {
  display: block;
  width: min(16rem, 80vw);
  height: auto;
  border: var(--space-2) solid var(--color-text-primary);
  border-radius: var(--radius-surface);
  background: var(--color-text-primary);
  image-rendering: pixelated;
}

.backupCodes {
  padding: var(--space-2);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-surface);
  background: var(--color-surface);
}

.backupCodes h3,
.backupCodes p {
  margin-block-start: 0;
}

.backupCodes ul {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-1) var(--space-2);
  margin: 0;
  padding-inline-start: 1.5rem;
}

.backupCodes code {
  color: var(--color-text-body);
  font-size: 0.95rem;
  user-select: all;
}

@media (max-width: 680px) {
  .screen {
    place-items: start stretch;
    padding-block-start: max(var(--space-2), env(safe-area-inset-top));
    padding-block-end: max(var(--space-3), env(safe-area-inset-bottom));
    padding-inline-start: max(var(--space-2), env(safe-area-inset-left));
    padding-inline-end: max(var(--space-2), env(safe-area-inset-right));
  }

  .card,
  .cardWide {
    align-self: start;
    margin: 0 auto;
    padding: var(--space-2);
    border-radius: var(--radius-surface);
  }

  .setupChoices {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 390px) {
  .backupCodes ul {
    grid-template-columns: minmax(0, 1fr);
  }
}

